export const HTTP_DATAROOM_2FA_SMS = "498";
export const HTTP_DATAROOM_2FA_REQUIRED = "497";
export const HTTP_DATAROOM_2FA_AUTHENTICATOR = "499";
export const HTTP_DATAROOM_2FA_AUTHENTICATOR2 = "499";
